'use strict';

const isMedium = require('../utils/isMedium');

function focusSkipLink() {
	const $el = $('.skip-link').first();
	if (!$el.length) return;
	const el = $el[0];

	$el.on('keydown', function onSkipLinkKeydown(e) {
		if (e.key !== 'Tab' || e.shiftKey) return;

		if (isMedium()) {
			return;
		}

		const $navbarToggler = $('.navbar-toggler').filter(':visible').first();
		if ($navbarToggler.length) {
			e.preventDefault();
			$navbarToggler[0].focus();
		}
	});
}

function focusAfterPaint() {
	requestAnimationFrame(() => {
		focusSkipLink();
	});
}

$(() => {
	if (document.readyState === 'complete') {
		focusAfterPaint();
	} else {
		$(window).one('load', focusAfterPaint);
	}
});
